// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import App from './App'
import router from './router'
const moment = require('moment')

Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(iView)
/* 加载 i18n */
const i18n = new VueI18n({
  locale: 'zh', // 语言标识
  // this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    // eslint-disable-next-line
    'zh': require('./language/zh.json'), // 简体中文语言包
    // eslint-disable-next-line
    'en': require('./language/en.json'), // 英文语言包
  }
})
// 时间过滤器
Vue.filter('moment', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD HH:mm:ss'
  if (value) {
    return moment(value).format(formatString)
  } else {
    return ''
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  iView,
  i18n,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js